import React from 'react';
import { Controller } from 'react-hook-form';
import { FormattedMessage } from 'react-intl';
import ReactSelect, { Options } from 'react-select';
import Group from '../group';
import Label from '../label';
import ValidationErrors from '../validation-errors';

type OptionT = { label: string; value: string };
export interface SelectProps {
  helper?: string | React.ReactNode;
  label?: string;
  [key: string]: any;
  options: Options<OptionT>;
  isSearchable?: boolean;
  isClearable?: boolean;
  style?: any;
}

const Select: React.FC<SelectProps> = ({
  options,
  isSearchable = false,
  isClearable = false,
  defaultValue,
  helper,
  formState,
  label,
  control,
  //@TODO : @degration.
  style,
  ...restProps
}) => {
  const { errors, isSubmitted } = formState;

  const customStyles = {
    ...style,
    control: (base, state) => ({
      ...base,
      border:
        isSubmitted && errors[restProps.name]
          ? '2px solid red'
          : '1px solid #4F4F4F', // default border color
      '&:hover': !errors[restProps.name] && {
        border: state.isFocused ? '2px solid #1a335b' : '2px solid gray',
        margin: '-1px',
      }, // border style on hover
      boxShadow: 'none', // no box-shadow
    }),
    option: (provided) => ({
      ...provided,
      borderRadius: 6,
    }),
    singleValue: (provided, state) => {
      const opacity = state.isDisabled ? 0.5 : 1;
      const transition = 'opacity 300ms';

      return { ...provided, opacity, transition };
    },
  };

  return (
    <Group>
      {label && (
        <Label htmlFor={restProps.name}>
          <FormattedMessage id={label} />
        </Label>
      )}
      <div className="relative">
        {/* @TODO : Maybe it's better to warrape Select component rather than here  */}
        <Controller
          name={restProps.name}
          defaultValue={defaultValue}
          control={control}
          render={({ field }) => {
            const selected = options.find((v) => v.value === field.value);
            return (
              <ReactSelect
                placeholder="Bitte wählen"
                options={options}
                isSearchable={isSearchable}
                isClearable={isClearable}
                onChange={(e) => {
                  e && field.onChange(e.value);
                }}
                value={selected}
                theme={(theme) => ({
                  ...theme,
                  borderRadius: 10,
                  spacing: {
                    ...theme.spacing,
                    controlHeight: 30,
                    baseUnit: 8,
                  },
                  colors: {
                    ...theme.colors,
                    primary: '#1a335b',
                    neutral80: '#1a335b',
                  },
                })}
                styles={customStyles}
                // required to avoid z-index issue
                menuPortalTarget={style && document.querySelector('body')}
                menuPosition={'absolute'}
              />
            );
          }}
        />
      </div>
      <ValidationErrors
        errors={errors[restProps.name]?.message}
        helper={helper}
        isSubmitted={isSubmitted}
      />
    </Group>
  );
};

export default Select;
